import React from 'react'
import { css } from '@linaria/core'
import { colors } from '@fs/zion-ui'

const eventIconCss = css`
  width: 22px;
  height: 22px;
  border-radius: 104px;
  background-position: center;
  background-color: ${colors.gray20};
  margin: 16px 0 16px 2px;
  &[gender='MALE'] {
    background-color: ${colors.blue70};
  }
  &[gender='FEMALE'] {
    background-color: ${colors.red70};
  }
`

/**
 * Icon component for WorldEvents info card.
 * @param {object} props - Props
 * @returns {JSX} Component
 */
export default function EventIcon({ gender }) {
  return <div aria-hidden className={eventIconCss} gender={gender} />
}
